import { ROLES_MAP } from '@shared/constants/roles-map';
import Joi from 'joi';
import { UserTiers } from '../../../../../../constants/userTiers';

export const MoveLicenseToOrgValidator = {
  schema: Joi.object()
    .keys({
      selectedOrgUnit: Joi.any().when('systemRoleId', {
        is: Joi.valid(...ROLES_MAP[UserTiers.OrgUnit]),
        then: Joi.number().required(),
        otherwise: Joi.array().allow(null)
      })
    })
    .unknown(true)
};
